import React from "react";
import { Route, Switch, Prompt } from "react-router-dom";
import Home from "./containers/home/Home";
import PropertySearch from "./containers/property/PropertySearch";
import LeaseSearch from "./containers/property/LeaseSearch";
import OwnerSearch from "./containers/owner/OwnerSearch";
import EntitySearch from "./containers/entity/EntitySearch";
import CityscopeList from "./containers/common/CityscopeList";
import ScheduleList from "./containers/common/ScheduleList";
import ArticleCategoryList from "./containers/common/ArticleCategoryList";
import CountryList from "./containers/common/CountryList";
import CPIRatesList from "./containers/common/CPIRatesList";
import MergerSubsList from "./containers/mergersubs/MergerSubsList";
import MergerSubsExport from "./containers/mergersubs/MergerSubsListExport";
import UserList from "./containers/common/UserList";
import AuSuburbList from "./containers/common/AuSuburbList";
import NzSuburbList from "./containers/common/NzSuburbList";
import WalkCopyList from "./containers/common/WalkCopyList";
import SalutationList from "./containers/common/SalutationList";
import PositionList from "./containers/common/PositionList";
import HeadOfficeSearch from "./containers/headoffice/HeadOfficeSearch";
import PropertyDetail from "./containers/property/PropertyDetail";
import SaleSheetDetail from "./containers/salesheet/SaleSheetDetail";
import OwnerDetail from "./containers/owner/OwnerDetail";
import ProposalDetail from "./containers/proposal/ProposalDetail";
import ArticleDetail from "./containers/article/ArticleDetail";
import LeaseDetail from "./containers/property/LeaseDetail";
import SaleDetail from "./containers/sale/SaleDetail";
import EntityDetail from "./containers/entity/EntityDetail";
import HeadOfficeDetail from "./containers/headoffice/HeadOfficeDetail";
import QueryDetail from "./containers/property/QueryDetail";
import TextPreview from "./containers/property/TextPreview";
import ProofingDetail from "./containers/proofing/ProofingDetail";
import WithholdingProofing from "./containers/proofing/WithholdingProofing";
import HybridProofingDetail from "./containers/proofing/HybridProofingDetail";

import SaleSheetFollowUpQueue from "./containers/queues/SaleSheetFollowUpQueue";
import SaleSheetFollowUpQueueDetail from "./containers/queues/SaleSheetFollowUpQueueDetail";
import AsicSearchQueue from "./containers/queues/AsicSearchQueue";
import QueriesQueue from "./containers/queues/QueriesQueue";
import SalesFeedQueue from "./containers/queues/SalesFeedQueue";
import IntroPgXDetail from "./containers/intropgx/IntroPgXDetail";

import SLMAddressSearch from "./containers/slm/SLMAddressSearch";
import SLMAddressDetail from "./containers/slm/SLMAddressDetail";
import SLMCategories from "./containers/slm/SLMCategoriesList";
import SLMSuburbList from "./containers/slm/SLMSuburbList";
import SLMRCASuppressionList from "./containers/slm/SLMRCASuppressionList";
import SLMRCAKeywordSuppressionList from "./containers/slm/iscompanykeywords";

import SLMSaleSearch from "./containers/slm/SLMSaleSearch";
import SLMSaleDetail from "./containers/slm/SLMSaleDetail";
import SLMLeaseSearch from "./containers/slm/SLMLeaseSearch";
import SLMLeaseDetail from "./containers/slm/SLMLeaseDetail";
import SLMEntityDetail from "./containers/slm/SLMEntityDetail";
import SLMOwnerDetail from "./containers/slm/SLMOwnerDetail";

import CoapiDemo from "containers/coapidemo/CoapiDemo";

import NotFound from "./containers/common/NotFound";

import AppliedRoute from "./components/AppliedRoute";

export default ({ childProps }) =>
    <Switch>
        <AppliedRoute path="/" exact component={Home} props={childProps} />
        <AppliedRoute path="/properties" exact component={PropertySearch} props={childProps} />
        <AppliedRoute path="/cityscopes" exact component={CityscopeList} props={childProps} />
        <AppliedRoute path="/schedules/:cityscope" exact component={ScheduleList} props={childProps} />
        <AppliedRoute path="/articlecategories" exact component={ArticleCategoryList} props={childProps} />
        <AppliedRoute path="/countries" exact component={CountryList} props={childProps} />
        <AppliedRoute path="/cpirates" exact component={CPIRatesList} props={childProps} />
        <AppliedRoute path="/mergersubs" exact component={MergerSubsList} props={childProps} />
        <AppliedRoute path="/mergersubsexport" exact component={MergerSubsExport} props={childProps} />
        <AppliedRoute path="/users" exact component={UserList} props={childProps} />
        <AppliedRoute path="/ausuburbs" exact component={AuSuburbList} props={childProps} />
        <AppliedRoute path="/nzsuburbs" exact component={NzSuburbList} props={childProps} />
        <AppliedRoute path="/walkcopy" exact component={WalkCopyList} props={childProps} />
        
        <AppliedRoute path="/salutations" exact component={SalutationList} props={childProps} />
        <AppliedRoute path="/positions" exact component={PositionList} props={childProps} />
        <AppliedRoute path="/queues/salesheets" exact component={SaleSheetFollowUpQueue} props={childProps} />
        <AppliedRoute path="/queues/salesheets/:id" exact component={SaleSheetFollowUpQueueDetail} props={childProps} />
        <AppliedRoute path="/queues/asicsearches" exact component={AsicSearchQueue} props={childProps} />
        <AppliedRoute path="/queues/queries" exact component={QueriesQueue} props={childProps} />
        <AppliedRoute path="/queues/salesfeed" exact component={SalesFeedQueue} props={childProps} />
        
        <AppliedRoute path="/owners" exact component={OwnerSearch} props={childProps} />
        <AppliedRoute path="/entities" exact component={EntitySearch} props={childProps} />
        <AppliedRoute path="/headoffices" exact component={HeadOfficeSearch} props={childProps} />
        
        <AppliedRoute path="/signin" exact component={PropertySearch} props={childProps} />
        { /*<AppliedRoute path="/property/new" exact component={PropertyDetail} props={childProps} /> */}
        <AppliedRoute path="/properties/:id" exact component={PropertyDetail} props={childProps} />
        <AppliedRoute path="/properties/:propertyid/leases/:id" exact component={LeaseDetail} props={childProps} />
        <AppliedRoute path="/leases" exact component={LeaseSearch} props={childProps} />
        <AppliedRoute path="/properties/:propertyid/queries/:id" exact component={QueryDetail} props={childProps} />
        <AppliedRoute path="/properties/:propertyid/previewtext" exact component={TextPreview} props={childProps} />

        <AppliedRoute path="/owners/:id" exact component={OwnerDetail} props={childProps} />
        <AppliedRoute path="/properties/:propertyid/owners/:id" exact component={OwnerDetail} props={childProps} />

        <AppliedRoute path="/proposals/:id" exact component={ProposalDetail} props={childProps} />
        <AppliedRoute path="/properties/:propertyid/proposals/:id" exact component={ProposalDetail} props={childProps} />

        <AppliedRoute path="/articles/:id" exact component={ArticleDetail} props={childProps} />
        <AppliedRoute path="/properties/:propertyid/articles/:id" exact component={ArticleDetail} props={childProps} />
      
        <AppliedRoute path="/salesheets/:id" exact component={SaleSheetDetail} props={childProps} other="" onLeave={ ()=>{console.log("Boo")} }/>
        <AppliedRoute path="/properties/:propertyid/salesheets/:id" exact component={SaleSheetDetail} props={childProps} />

        <AppliedRoute path="/sales/:id" exact component={SaleDetail} props={childProps} />
        <AppliedRoute path="/properties/:propertyid/sales/:id" exact component={SaleDetail} props={childProps} />

        <AppliedRoute path="/entities/:id" exact component={EntityDetail} props={childProps} />
        <AppliedRoute path="/headoffices/:id" exact component={HeadOfficeDetail} props={childProps} />

        <AppliedRoute path="/proofing" exact component={ProofingDetail} props={childProps} />
        <AppliedRoute path="/proofing/WithholdingProofing" exact component={WithholdingProofing} props={childProps} />
        <AppliedRoute path="/proofing/ad-hoc" exact component={HybridProofingDetail} props={childProps} />
        
        <AppliedRoute path="/intropgx" exact component={IntroPgXDetail} props={childProps} />

     
        <AppliedRoute path="/slmaddresses" exact component={SLMAddressSearch} props={childProps} />
        <AppliedRoute path="/slmaddresses/:id" exact component={SLMAddressDetail} props={childProps} />
        <AppliedRoute path="/slmsales/:id" exact component={SLMSaleDetail} props={childProps} />
        <AppliedRoute path="/slmleases/:id" exact component={SLMLeaseDetail} props={childProps} />
        <AppliedRoute path="/slmentities/:id" exact component={SLMEntityDetail} props={childProps} />
        <AppliedRoute path="/slmowners/:id" exact component={SLMOwnerDetail} props={childProps} />
        <AppliedRoute path="/slmcategories" exact component={SLMCategories} props={childProps} />
        <AppliedRoute path="/slmsuburbs" exact component={SLMSuburbList} props={childProps} />
        <AppliedRoute path="/slmrcasuppressionlist" exact component={SLMRCASuppressionList} props={childProps} />
        <AppliedRoute path="/iscompanykeywords" exact component={SLMRCAKeywordSuppressionList} props={childProps} />
        <AppliedRoute path="/slmproofingadhoc" exact component={HybridProofingDetail} props={childProps} />
        
        <AppliedRoute path="/slmsales" exact component={SLMSaleSearch} props={childProps} />
        <AppliedRoute path="/slmleases" exact component={SLMLeaseSearch} props={childProps} />
        {/*<AppliedRoute path="/slmagency/:id" exact component={SLMAgencyDetail} props={childProps} />*/}

        <AppliedRoute path="/coapidemo" exact component={CoapiDemo} props={childProps} />

        { /* Finally, catch all unmatched routes */}
        <Route component={NotFound} />
    </Switch>;